/**
 * Toast Hook - Wrapper for Sonner
 * Provides consistent toast notifications
 */

import { toast, type ExternalToast } from 'sonner';

export function useToast() {
  const showSuccess = (message: string, options?: ExternalToast) => {
    toast.success(message, options);
  };

  const showError = (message: string, options?: ExternalToast) => {
    toast.error(message, { duration: 5000, ...options });
  };

  const showWarning = (message: string, options?: ExternalToast) => {
    toast.warning(message, options);
  };

  const showInfo = (message: string, options?: ExternalToast) => {
    toast.info(message, options);
  };

  const showLoading = (message: string) => {
    return toast.loading(message);
  };

  const dismiss = (toastId?: string | number) => {
    toast.dismiss(toastId);
  };

  const showPromise = <T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string | ((data: T) => string);
      error: string | ((error: unknown) => string);
    }
  ) => {
    return toast.promise(promise, messages);
  };

  return {
    success: showSuccess,
    error: showError,
    warning: showWarning,
    info: showInfo,
    loading: showLoading,
    dismiss,
    promise: showPromise,
  };
}
